'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackPageVisit } from '@/lib/tracking';

/**
 * Tracks page visits in sessionStorage on every route change.
 * Cookieless — no consent needed. Data is session-only (cleared when tab closes).
 * Used to build pages_visited string sent with form submissions.
 */
export function PageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    trackPageVisit();
  }, [pathname]);

  return null;
}
